import { BrowserRouter } from 'react-router-dom';
import { SessionProvider } from './contexts/SessionContext';
import Header from './components/Header/index.js';
import AppRoutes from './AppRoutes.js';

function App() {
  return (
    <BrowserRouter basename="/trav-referral">
      <SessionProvider>
        <Header />
        <AppRoutes />
      </SessionProvider>
    </BrowserRouter>
  );
}

export default App;
